import React from 'react';
import styled from 'styled-components';
import {
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import { ProcedureInfoComponent } from '../info/components/ProcedureInfoComponent';
import {
  ToggleHeader,
  TextTitle
} from '../../../certificates-constancies/type1/register/components';
import { BackButton, FileUploader } from '../../../../components';
import { Block } from '../../../../../../components';
import Select from '../../../../../../reusables/Select';
import Step from '../../UpdatePhoto/Register/components/Step';
import QuitPageModal from '../../CertificateOfStudies/dialogs/QuitPageModal';
import {
  optionslist,
  TypeEvaluation,
  NoteCourse,
  showNotes
} from './helpers/options-list';
import { InputField } from '../../../registerTicket/RegisterTicketView';
import { SaveButton } from '../../../scholarships/bse/components/styled';
import Processing from '@/presentation/components/Processing';
import Modal from '../../../../components/Modal/Modal';
import RequestExist from '@/presentation/modules/procedures/components/Modals/RequestExists';
import WarningComponent from './helpers/WarningComponent';
import Spinner from '@/presentation/components/Spinner';
import RectificationTeacherModal from './components/RectificationTeacherRestriction';

const Container = styled.div`
  color: #161d1f;
  padding: 24px;
  background-color: #fff;
  border-radius: 4px;
  margin: 16px 0px 32px 0px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const RectificationRegisterView = ({
  handlerBackButton,
  open,
  procedureInfo,
  course,
  isLoadingEvaluation,
  typeEvaluation,
  evaluation,
  reason,
  comment,
  file,
  SendFiles,
  sendRegister,
  isProcessingRegister,
  backProcedures,
  fileError,
  teacherEvaluation
}: any) => {
  const { openBack, setOpenBack } = open;
  const { selectCourse, setSelectCourse } = course;
  const { selectEvaluation, setSelectEvaluation } = evaluation;
  const { selectReason, setSelectReason } = reason;
  const { comentary, setComentary } = comment;
  const { setFiles } = file;
  const { error, setError } = fileError;
  const { teacherRestriction, setTeacherRestriction } = teacherEvaluation;

  return (
    <ContainerProcedure>
      <SubContainer>
        <BackButton
          onClick={() =>
            selectCourse ? setOpenBack(true) : handlerBackButton()
          }
        />
      </SubContainer>
      <br />
      <Processing isOpen={isProcessingRegister} />
      {!procedureInfo && <Spinner />}
      {procedureInfo && (
        <SubContainer>
          <ToggleHeader
            name={procedureInfo.name}
            amount={procedureInfo.amount}
            duration={procedureInfo.duration}
            childContent={<ProcedureInfoComponent />}
          />
          <TextTitle title="Progreso" />
          <Block customized padding="28px 0px 45px 8px">
            <Step name={'Registrar solicitud'} order={1}>
              <Container>
                <Select
                  onChange={(e: any) => {
                    setSelectCourse(e);
                    setSelectEvaluation(null);
                    setSelectReason(null);
                    setComentary('');
                  }}
                  placeholder="Selecciona el curso"
                  itemCount={3}
                  itemName={'name'}
                  itemValue={'value'}
                  label={'Curso'}
                  value={selectCourse}
                  items={optionslist(
                    procedureInfo.detail.coursesToRectification
                  )}
                  isLoading={isLoadingEvaluation}
                  error={
                    (!typeEvaluation?.procedures?.evaluationsTobeCorrected ||
                      typeEvaluation?.procedures?.evaluationsTobeCorrected
                        ?.length === 0) &&
                    !isLoadingEvaluation &&
                    selectCourse
                  }
                />
                <Select
                  items={
                    typeEvaluation?.procedures?.evaluationsTobeCorrected &&
                    typeEvaluation?.procedures?.evaluationsTobeCorrected
                      .length > 0
                      ? TypeEvaluation(
                          typeEvaluation?.procedures?.evaluationsTobeCorrected
                        )
                      : []
                  }
                  isDisabled={
                    !typeEvaluation?.procedures?.evaluationsTobeCorrected ||
                    typeEvaluation?.procedures?.evaluationsTobeCorrected
                      ?.length === 0
                  }
                  onChange={(e: any) => {
                    setSelectEvaluation(e);
                    setSelectReason(null);
                  }}
                  placeholder="Selecciona la evaluación"
                  itemCount={4}
                  itemName={'name'}
                  itemValue={'value'}
                  label={'Evaluación'}
                  value={selectEvaluation}
                />
                <p>
                  Nota a rectificar:{' '}
                  <span
                    style={{
                      color: '#4F6168'
                    }}
                  >
                    {showNotes(
                      selectEvaluation,
                      typeEvaluation?.procedures?.evaluationsTobeCorrected
                    )}
                  </span>
                </p>
                <hr />
                <Select
                  items={NoteCourse(procedureInfo.detail.rectificationReasons)}
                  isDisabled={
                    !typeEvaluation?.procedures?.evaluationsTobeCorrected ||
                    typeEvaluation?.procedures?.evaluationsTobeCorrected
                      ?.length === 0
                  }
                  onChange={(e: any) => setSelectReason(e)}
                  placeholder="Selecciona el motivo"
                  itemCount={2}
                  itemName={'name'}
                  itemValue={'value'}
                  label={'Motivo de la rectificación'}
                  value={selectReason}
                />
                <div>
                  <p
                    style={{
                      marginBottom: 4
                    }}
                  >
                    Describe más detalle sobre tu solicitud
                  </p>
                  <InputField
                    error={comentary.length > 200}
                    errorText="Excediste el número de caracteres"
                    textarea
                    value={comentary}
                    placeholder="Ingresa aquí tu comentario"
                    name="commentary"
                    showCount="200"
                    maxLength="200"
                    setValue={({ value }: any) => {
                      setComentary(value);
                    }}
                    disabled={
                      !typeEvaluation?.procedures?.evaluationsTobeCorrected ||
                      typeEvaluation?.procedures?.evaluationsTobeCorrected
                        ?.length === 0
                    }
                  />
                </div>
                <div>
                  <p style={{ marginBottom: 8 }}>Documento de sustento</p>
                  <WarningComponent>
                    Revisa los{' '}
                    <a
                      data-testid="lnk-sustento"
                      href="https://drive.google.com/file/d/1nS90GBEwOKQCGXbTNNeCEm6qV8yv8mE3/view"
                      onClick={() => {}}
                      style={{
                        color: 'var(--text-primary)',
                        textDecorationLine: 'underline'
                      }}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {'ejemplos de sustento'}
                    </a>{' '}
                    para evaluaciones virtuales.
                  </WarningComponent>
                </div>
                <FileUploader
                  allowedFormats=".jpeg,.jpg,.png,.pdf"
                  displayFormats="JPG, PNG, PDF"
                  maxFileSize={4}
                  maxAllowFiles={1}
                  disabled={
                    !typeEvaluation?.procedures?.evaluationsTobeCorrected ||
                    typeEvaluation?.procedures?.evaluationsTobeCorrected
                      ?.length === 0
                  }
                  onFilesReady={(e: any) => {
                    setFiles(e);
                    setError(false);
                  }}
                  onFilesClean={() => {
                    setError(true);
                  }}
                  onFilesError={() => {
                    setError(true);
                  }}
                />
                <div>
                  <SaveButton
                    disabled={
                      !typeEvaluation?.procedures?.evaluationsTobeCorrected ||
                      selectEvaluation === null ||
                      selectReason === null ||
                      error ||
                      comentary.length > 200 ||
                      !comentary
                    }
                    style={{
                      marginTop: 16
                    }}
                    onClick={SendFiles}
                    type="button"
                    data-testid="btn-register-retreatCourse"
                  >
                    Enviar solicitud
                  </SaveButton>
                </div>
              </Container>
            </Step>
            <Step
              name={'Revisar estado de solicitud'}
              order={2}
              disabled
              isLast
            >
              <></>
            </Step>
          </Block>
        </SubContainer>
      )}

      <QuitPageModal
        handlerBack={handlerBackButton}
        handlerClose={() => setOpenBack(false)}
        show={openBack}
      />
      <Modal
        show={teacherRestriction}
        handleClose={() => setTeacherRestriction(false)}
      >
        <RectificationTeacherModal
          handleClick={() => setTeacherRestriction(false)}
        />
      </Modal>
      <Modal show={sendRegister} handleClose={backProcedures}>
        <RequestExist rectificationNotes handleClick={backProcedures} />
      </Modal>
    </ContainerProcedure>
  );
};

export default RectificationRegisterView;
